import React from 'react';
import { company } from '../data/content';
import { EstimateForm } from './EstimateForm';
import { PhoneIcon, MailIcon, ArrowRightIcon, ShieldIcon, ClockIcon } from './icons';
export function FinalCta() {
  return <section id="contact" className="w-full bg-navy-900 py-20 lg:py-24" data-id="element-170" data-mp="19g0cbghttsjd">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-171" data-mp="15dlxr8l6xexw">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,5fr)_minmax(0,6fr)] lg:gap-16" data-id="element-172" data-mp="15fghijkq710e">
          <div data-id="element-173" data-mp="1jbahgd3iug1d">
            <p className="text-sm font-semibold text-sky-300" data-id="element-174" data-mp="1jasbgor24ng9">The smart next step</p>
            <h2 className="mt-3 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-175" data-mp="1eds6kh5y1qqq">
              Don&apos;t wait another season for your pool to get worse.
            </h2>
            <p className="mt-5 max-w-xl text-lg leading-relaxed text-navy-100" data-id="element-176" data-mp="1o67m77trq38g">
              Most people read this, think &ldquo;I&apos;ll call later,&rdquo; and wait six more
              months. Fill out the form and we&apos;ll come out, assess the pool, and quote
              honestly — no obligation, no sales pitch.
            </p>

            <ul className="mt-8 space-y-4 border-t border-navy-700 pt-8" data-id="element-177" data-mp="s3w3eicijeq4">
              <li className="flex items-start gap-3 text-[15px] text-navy-100" data-id="element-178" data-mp="x41y67e2xhcf">
                <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-sky-300" data-id="element-179" data-mp="x64z3mgrsuvx" />
                We respond within one business day — you&apos;ll talk to a real person, not a phone
                tree.
              </li>
              <li className="flex items-start gap-3 text-[15px] text-navy-100" data-id="element-180" data-mp="1b3a0va9gb7ld">
                <ShieldIcon className="mt-0.5 h-5 w-5 shrink-0 text-sky-300" data-id="element-181" data-mp="1b16zxv6rfu1v" />
                Licensed and insured for 20 years, with proof available on request.
              </li>
            </ul>

            <div className="mt-8 space-y-3" data-id="element-182" data-mp="1kv7e0mk0s9mq">
              <a href={company.phoneHref} className="flex items-center justify-between gap-4 rounded-md bg-sky-400 px-5 py-4 transition-colors duration-150 ease-out hover:bg-sky-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-200" data-id="element-183" data-mp="1pt8y9at6mezs">
                <span className="flex items-center gap-3" data-id="element-184" data-mp="3lxf6lbjzobzg">
                  <PhoneIcon className="h-5 w-5 text-navy-900" data-id="element-185" data-mp="3imuaepzqzct" />
                  <span className="font-display text-xl font-extrabold tracking-tight text-navy-900" data-id="element-186" data-mp="3uwah2zu2g88k">
                    {company.phoneDisplay}
                  </span>
                </span>
                <ArrowRightIcon className="h-5 w-5 text-navy-900" data-id="element-187" data-mp="dhlqgxtkl2ix" />
              </a>
              <a href={company.emailHref} className="flex items-center justify-between gap-4 rounded-md border border-navy-600 px-5 py-4 transition-colors duration-150 ease-out hover:border-sky-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-200" data-id="element-188" data-mp="8iscz5ea9bir">
                <span className="flex min-w-0 items-center gap-3" data-id="element-189" data-mp="2k7a6s21hdszb">
                  <MailIcon className="h-5 w-5 shrink-0 text-sky-300" data-id="element-190" data-mp="2a2k05iv4u0or" />
                  <span className="truncate text-[15px] font-semibold text-white" data-id="element-191" data-mp="2a4em90i53yuf">
                    {company.email}
                  </span>
                </span>
                <ArrowRightIcon className="h-5 w-5 shrink-0 text-navy-200" data-id="element-192" data-mp="20bpd4ca2ax29" />
              </a>
            </div>
          </div>

          <EstimateForm data-id="element-193" data-mp="259qsam4dac8g" />
        </div>
      </div>
    </section>;
}